import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map } from 'rxjs/operators';
import { esNumeroActivoValido, validarNumeroActivo } from '@/app/services/security/input-validation';
import { UrlValidationService } from '@/app/services/security/url-validation.service';

@Injectable({
  providedIn: 'root'
})
export class ActivosService {

  private urlValidation = inject(UrlValidationService);

  /** Endpoint validado contra la lista blanca de orígenes aprobados. */
  private readonly endpoint: string;

  constructor
  (
    private httpClient: HttpClient
  ) 
  { 
    this.endpoint = this.urlValidation.construirEndpointApi('/catalogos/CatalogoEquipo');
  }

   getEquipos(parametros: any) {
    return this.httpClient.post(this.endpoint + '/GetActivos', parametros);
   }

   getDetalleActivo(numActivo: string): Observable<any> {
    // Validación con lista blanca antes de usar el valor en la petición.
    if (!esNumeroActivoValido(numActivo)) {
      return throwError(() => new Error('El número de activo no cumple el formato permitido.'));
    }
    const activoValidado = validarNumeroActivo(numActivo);
    // El valor no se concatena a la URL: se envía como parámetro codificado.
    const params = new HttpParams().set('numActivo', activoValidado);
    return this.httpClient.post(this.endpoint + '/GetDetalleActivo', {}, { params });
   }

   insertActivo(form: any) {
    return this.httpClient.post(this.endpoint + `/InsertActivo`, form);
   }
  
  obtenerActivosCatalog(parametros: any) {
    return this.getEquipos(parametros).pipe(
      map((data: any) => {
        if (data?.response) {
          return data.response
            .filter((i: any) => i.Activo) 
            .map((i: any) => ({
              label: `${i.Activo}`, 
              value: i.Activo
            }));
        }
        return [];
      })
    );
  }
   
}
